// @ngInject
function VatsApiService($q, $rootScope, DS, DSHttpAdapter, ResourcesService) {
  var endpoint = "vats";

  return {
    getAccounts: getAccounts,
    getVats: getVats,
    getVat: ResourcesService.apiRms2Factory.get(endpoint),
    createVat: ResourcesService.apiRms2Factory.create(endpoint, "Vat"),
    updateVat: ResourcesService.apiRms2Factory.update(endpoint, "Vat"),
    deleteVat: ResourcesService.apiRms2Factory.delete(endpoint, "Vat"),
  };
  function getAccounts() {
    var deferred = $q.defer();

    DSHttpAdapter.GET(DS.defaults.rms2Path + endpoint + "/accounts").then(
      function (response) {
        deferred.resolve(response.data.accounts);
      },
      function (error) {
        deferred.reject(handleError(error));
      }
    );
    return deferred.promise;
  }

  function getVats(params) {
    var deferred = $q.defer();

    DSHttpAdapter.GET(DS.defaults.rms2Path + endpoint, { params: params }).then(
      function (response) {
        deferred.resolve(response.data.vats);
      },
      function (error) {
        deferred.reject(handleError(error));
      }
    );

    return deferred.promise;
  }

  function handleError(error) {
    return ResourcesService.handleResourceError(error);
  }
}

angular.module("vats.api", []).factory("VatsApiService", VatsApiService);
